import React from 'react';
import styled from 'styled-components';

import ReviewLeftComponent from '../ReviewLeftComponent/ReviewLeftComponent';
import ReviewRightComponent from '../ReviewRightComponent/ReviewRightComponent';

const RnRReview = () => (
  <RnRReviewWrapDiv>
    <ReviewLeftComponent></ReviewLeftComponent>
    <ReviewRightComponent></ReviewRightComponent>
  </RnRReviewWrapDiv>
);

export default RnRReview;

const RnRReviewWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  width:100%;
  justify-content: space-between;


`,
);
